// ============================================
// 📱 APP: NVA (React App)
// 📄 FILE: src/data/mapPois.ts
// 🔧 PURPOSE: I punti della mappa che servono anche fuori dalla mappa. Il
//   riquadro "Mappe" di Esplora vuole la spiaggia più vicina, ma importare
//   MapApp trascinerebbe Leaflet dentro un hook di soli dati: qui restano
//   le sole coordinate, uguali a quelle dei POI `beaches` di MapApp.
// ============================================

export interface MapPoi {
  name: string;
  lat: number;
  lon: number;
  category: string;
}

/** Spiagge/lidi convenzionati, stesse coordinate dei POI `beaches` di MapApp. */
export const BEACH_POIS: MapPoi[] = [
  { name: 'NIRVANA BEACH', lat: 41.06474, lon: 17.08576, category: 'beaches' },
  { name: 'LAS PALMAS COZZE', lat: 41.0389, lon: 17.1394, category: 'beaches' },
];
